"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssClass = exports.keyframes = exports.classes = void 0;
const typestyle_1 = require("typestyle");
var typestyle_2 = require("typestyle");
Object.defineProperty(exports, "classes", { enumerable: true, get: function () { return typestyle_2.classes; } });
Object.defineProperty(exports, "keyframes", { enumerable: true, get: function () { return typestyle_2.keyframes; } });
function cssClass(name, ...styles) {
    return (0, typestyle_1.style)(...styles, {
        $debugName: `datacatalog_${name}`,
        $unique: true,
    });
}
exports.cssClass = cssClass;
//# sourceMappingURL=StyleFunctions.js.map